module.exports = __webpack_public_path__ + "img/newchris-45.ef2584fd.jpg";